import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { LoginSyncPlatformRegisterPage } from './login-sync-platform-register';

@NgModule({
  declarations: [
    LoginSyncPlatformRegisterPage,
  ],
  imports: [
    IonicPageModule.forChild(LoginSyncPlatformRegisterPage),
  ],
})
export class LoginSyncPlatformRegisterPageModule {}



// WEBPACK FOOTER //
// ./src/pages/login-sync-platform-register/login-sync-platform-register.module.ts